<mat-card>

  <h3>Companies</h3>

  <div *ngIf="isLoadingCompanies" style="margin-top: 10px;">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <ng-container *ngIf="companies">
      <a [routerLink]="[company.id]" *ngFor="let company of companies">
      <div style="display: inline-block; width: 30%; max-width: 200px; text-align: center; padding: 10px; height: 80px; overflow: hidden; border: 1px solid gray; border-radius: 3px; margin: 10px;">
        <img *ngIf="company.logoUrl" class="logo" [src]="company.logoUrl" style="max-width: 180px; max-height: 40px;" alt="logo-{{company.id}}"/>
        <div style="font-size: .8em;">
        {{company.name}}
        </div>
      </div>
      </a>


  </ng-container>

  <h3>Invoices</h3>

  <div *ngIf="isLoadingInvoices" style="margin-top: 10px;">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <ng-container *ngIf="invoices">

    <table mat-table [dataSource]="invoices" #invoiceTable>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon style="cursor: pointer;" (click)="editInvoice(element.id, element.companyId)">edit</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="invoiceDate">
        <th mat-header-cell *matHeaderCellDef> Date </th>
        <td mat-cell *matCellDef="let element">
          {{ element.invoiceDate | date : 'yyyy-MM-dd' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef> # </th>
        <td mat-cell *matCellDef="let element">
          {{ element.invoiceNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef> Company </th>
        <td mat-cell *matCellDef="let element">
          {{element.company.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="netTotal">
        <th mat-header-cell *matHeaderCellDef> Invoice Net </th>
        <td mat-cell *matCellDef="let element">
          {{ element.netAmount | number : '1.2-2' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="commissionNetTotal">
        <th mat-header-cell *matHeaderCellDef> Commission Net </th>
        <td mat-cell *matCellDef="let element">
          {{ element.commissionNetAmount | number : '1.2-2' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="finished">
        <th mat-header-cell *matHeaderCellDef> Finished </th>
        <td mat-cell *matCellDef="let element">
          {{ element.isFinished ? 'Yes' : 'No' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="paid">
        <th mat-header-cell *matHeaderCellDef> Paid </th>
        <td mat-cell *matCellDef="let element">
          {{ element.isPaid ? 'Yes' : 'No' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


  </ng-container>


</mat-card>
